import RequestAcceptedItems from './RequestAcceptedItems';

export default RequestAcceptedItems;
